import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
   root : {
      padding : 10
   } ,
   gridIcon: {
      paddingTop: 10,
      paddingLeft: 10
   },
   icon : {
      fontSize : 40
   }
}))
